<template>
  <Transition name="fade">
    <div
      v-if="open"
      class="bg-modal-bgr-overlay fixed top-0 left-0 z-30 flex h-dvh w-full overflow-hidden p-1"
      @click="onBackgroundClick"
    >
      <div
        class="slide-in border-bdr-subtle bg-bgr-primary relative ml-auto flex w-full max-w-142 min-w-96 flex-col overflow-hidden rounded-xl border-2"
        @click.stop
      >
        <SlideInHeader
          :actions="actions"
          :is-subpage="isSubpage"
          :title="title"
          :prefix="titlePrefix"
          @back="emit('back')"
          @close="emit('close')"
        >
          <template v-if="actions.length || $slots.actions" #actions>
            <slot name="actions" />
          </template>
        </SlideInHeader>
        <slot />
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
  const {
    actions = [],
    clickToClose = true,
    isSubpage = false,
    open,
    title = undefined,
    titlePrefix = undefined,
  } = defineProps<{
    actions?: Array<DropdownOption>;
    clickToClose?: boolean;
    isSubpage?: boolean;
    open: boolean;
    title?: string;
    titlePrefix?: string | undefined;
  }>();

  const emit = defineEmits(["close", "submit", "back"]);
  const onBackgroundClick = () => {
    if (clickToClose) emit("close");
  };
</script>
